import React, { type ReactElement } from 'react';

export const MoveIconLarge = (): ReactElement => (
  <svg width="140px" height="121px" viewBox="0 0 140 121">
    <title>Move icon</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Zero_states_shortlist"
        transform="translate(-788.000000, -376.000000)"
      >
        <g id="Group-16" transform="translate(788.000000, 376.000000)">
          <line
            x1="22.7148"
            y1="95.7613"
            x2="70.9528"
            y2="95.7613"
            id="Stroke-1"
            stroke="#031D44"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="22.7148"
            y1="103.503"
            x2="50.5708"
            y2="103.795"
            id="Stroke-2"
            stroke="#031D44"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <g id="Group-15" transform="translate(0.000000, 0.444000)">
            <path
              d="M116.0996,79.6678 L15.1526,79.6678 C10.4786,79.6678 6.6896,83.4578 6.6896,88.1308 L6.6896,110.5368 C6.6896,115.2108 10.4786,118.9998 15.1526,118.9998 L116.0996,118.9998 C120.7736,118.9998 124.5626,115.2108 124.5626,110.5368 L124.5626,88.1308 C124.5626,83.4578 120.7736,79.6678 116.0996,79.6678 Z"
              id="Stroke-3"
              stroke="#031D44"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M120.9336,76.9266 L10.4306,84.5186 C5.8106,84.8126 1.8276,81.3056 1.5336,76.6866 L0.0176,51.4836 C-0.2764,46.8636 3.2306,42.8806 7.8496,42.5866 L118.3536,34.9946 C122.9726,34.7006 126.9556,38.2076 127.2496,42.8266 L128.7666,68.0306 C129.0606,72.6496 125.5536,76.6326 120.9336,76.9266"
              id="Fill-5"
              fill="#EAF0FA"
            />
            <path
              d="M131.3408,0.5555 L124.0688,5.5375 C124.0688,5.5375 110.6448,0.8345 104.7018,1.0295 C96.1178,1.3105 57.4898,11.1465 57.4898,11.1465 C57.4898,11.1465 58.8568,16.3675 64.8578,15.5535 C67.5288,15.1915 80.4378,12.2055 80.4378,12.2055 C80.4378,12.2055 60.0918,24.8985 58.8258,25.4455 C59.7068,26.7075 63.3308,29.4835 68.5048,26.0095 C71.6378,23.9065 91.4048,12.2385 91.4048,12.2385 L83.1838,19.8705 L76.5908,44.6085 C78.4648,44.8585 81.1278,43.4965 81.7778,41.4845 C82.4278,39.4725 87.7168,25.5795 87.7168,25.5795 C87.7168,25.5795 99.2948,19.2535 103.9038,18.6765 C108.5128,18.0985 111.0618,26.1675 110.8888,29.2445 C110.7168,32.3225 107.4068,36.0315 102.1858,42.6335 C86.7768,46.9215 91.5258,54.2335 91.5258,54.2335 L104.7968,50.2325 C104.7968,50.2325 119.8028,38.5925 125.6028,36.5985 C131.4028,34.6065 136.4858,28.0255 136.4858,28.0255 L138.9998,27.6445"
              id="Stroke-7"
              stroke="#031D44"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M90.2412,3.4857 L66.9532,4.4457 C66.9532,4.4457 68.0532,8.1997 71.8382,7.5027"
              id="Stroke-9"
              stroke="#031D44"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="19.5488"
              y1="58.7123"
              x2="67.6978"
              y2="55.7743"
              id="Stroke-11"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="19.956"
              y1="66.7518"
              x2="47.779"
              y2="65.3468"
              id="Stroke-13"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
